import React from 'react';
import logoImage from '../assets/images/theBeansLogoPrimary@3x.png';
import '../styles/passwordSuccess.css';


const PasswordSuccess = () => {
  return (
    <div className="password-success-screen">
      <div className="password-success-content">
        <img src={logoImage} alt="Logo" className="logo" />
        <h2 className="header-text">Password Update Confirmed</h2>
        <p className='sub-title'>Password updated successfully! You can now log in using your new password.</p>
      </div>
    </div>
  );
};

export default PasswordSuccess;
